import axios from 'axios';
const practiseid = 1111;
const dallasapi = axios.create({
  baseURL: '/v2/dallas',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});
(function checkAllowToken() {
  const params = new URLSearchParams(window.location.search);
  const allowToken = params.get('allowtoken');
  if (allowToken) {
    localStorage.setItem('auth', allowToken);
    console.log('[dallasapi] Token captured from URL and saved to localStorage');
  }
})();

dallasapi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth'); 
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      localStorage.removeItem('auth');
    //  window.location.replace('/auth');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
let isRefreshing = false;

const refreshAuthToken = async () => {
  try {
    const accessToken = localStorage.getItem('auth');
    const response = await dallasapi.post(
      `/v1/${practiseid}/auth/refresh-token`,
      { "access_token": accessToken },
      { headers: { 'Content-Type': 'application/json' } }
    );

    if (response && response.status === 200) {
      localStorage.setItem('auth', response.refresh_token);
      return response.refresh_token;
    } else {
     //localStorage.removeItem('auth');
      window.location.replace('/login');
      throw new Error('Failed to refresh token');
    }
  } catch (error) {
    //localStorage.removeItem('auth');
    window.location.replace('/login');
    console.error("Failed to refresh token:", error);
    throw error;
  }
};

dallasapi.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const newToken = await refreshAuthToken();
          if (newToken) {
            
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            isRefreshing = false;

            return dallasapi(originalRequest);
          }
        } catch (refreshError) {
          isRefreshing = false;
          return Promise.reject(refreshError);
        }
      } else {
    
       // localStorage.removeItem('auth');
     
        return Promise.reject(error);
      }
    }

    if (!originalRequest._retry) {
      //localStorage.removeItem('auth');
    }

    return Promise.reject(error);
  }
);

export default dallasapi;
